import React from 'react'
import classNames from 'classnames'

import './LoadingInterstitial.scss'

export const LoadingInterstitial = ({ lines, ...props }) => {
  return (
    <div className="loading-interstitial" data-testid="loading-interstitial" {...props}>
      {lines.map((line, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={classNames('shine', {
            'is-short': line.length === 'short',
            'is-medium': line.length === 'medium',
            'is-long': line.length === 'long',
            'is-image': line.type === 'image',
          })}
        />
      ))}
    </div>
  )
}
